import { message } from 'antd';
import { API_URL } from '../env';

export const mixFnum = (number: number) => {
  return new Intl.NumberFormat('vi-VN', { maximumSignificantDigits: 3 }).format(number);
}

export const mixToken = (type = 'get' as any) => {
  if (type === 'get') {
    let res = '' as any
    try {
      res = localStorage.getItem('token')
      if (!res) {
        res = sessionStorage.getItem('token')
      }
    } catch (error) {
      res = ''
    }
    return res
  }
  return
}

export const mixLogOut = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  localStorage.removeItem('userType')
  localStorage.removeItem('permissions')
  window.location.href = '/login'
}

/** Chỉ 401 mới là hết phiên. 403 là thiếu quyền ở thao tác đó: báo cho người dùng, giữ nguyên phiên đăng nhập */
const isAuthExpiredStatus = (status: number) => status === 401

/** Thao tác ghi bị từ chối: 401 đăng xuất; 403 hiện thông báo của server, cùng một key để không chồng nhiều dòng */
const handleWriteDenied = (response: Response) => {
  if (isAuthExpiredStatus(response.status)) { mixLogOut(); return }
  if (response.status !== 403) return
  response.clone().json().catch(() => null).then((json) => {
    message.warning({ key: 'forbidden', content: json?.message || json?.msg || 'Bạn không có quyền thực hiện thao tác này' })
  })
}

export const authFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const token = localStorage.getItem('token')
  const headers = {
    ...options.headers,
    Authorization: `Bearer ${token || ''}`,
  }
  const response = await fetch(`${API_URL}${url}`, { ...options, headers })
  if (isAuthExpiredStatus(response.status)) {
    mixLogOut()
    throw new Error('Unauthorized')
  }
  return response
}

export const mixGetV1 = async (url: string, params = {} as any) => {
  let hasQuery = false;
  Object.keys(params).map((isKey) => {
    if (params[isKey] || params[isKey] === 0) {
      if (Array.isArray(params[isKey])) {
        params[isKey].map((val: any) => {
          url = `${url}${hasQuery ? '&' : '?'}${isKey}=${val}`
          hasQuery = true;
          return true
        })
      } else {
        url = `${url}${hasQuery ? '&' : '?'}${isKey}=${params[isKey]}`
        hasQuery = true;
      }
    }
    return null
  })
  const response = await fetch(`${API_URL}${url}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
  if (!response.ok) {
    if (isAuthExpiredStatus(response.status)) {
      mixLogOut()
    }
    throw new Error('Network response was not ok');
  }
  const temp = await response.json()
  return temp
}

export const mixPostV1 = async (url: string, param: {}) => {
  const response = await fetch(`${API_URL}${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(param),
  })
  if (!response.ok) {
    handleWriteDenied(response)
  }
  const temp = await response.json()
  return temp
}

export const mixPostV2 = async (url: string, param: any) => {
  const token = mixToken();
  const formData = new FormData();

  Object.keys(param).forEach((key: any) => {
    const value = param[key];

    if (value !== null && value !== undefined) {

      // 👇 xử lý array
      if (Array.isArray(value)) {
        value.forEach((item) => {
          formData.append(`${key}[]`, item); // 👈 QUAN TRỌNG
        });
      } else {
        formData.append(key, value);
      }
    }
  });

  const response = await fetch(`${API_URL}${url}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      // ❌ KHÔNG set Content-Type
    },
    body: formData,
  });

  if (!response.ok) {
    handleWriteDenied(response)
  }

  const temp = await response.json();
  return temp;
};

export const mixPutV1 = async (url: string, param: any, option = {} as any) => {
  const token = mixToken()
  const formData = new FormData()
  Object.keys(param).map((keyParam: any) => {
    formData.append(keyParam, param[keyParam])
    return true
  })

  const response = await fetch(`${API_URL}${url}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(param),
  })
  if (!response.ok) {
    handleWriteDenied(response)
  }
  const temp = await response.json()
  return temp
}
export const mixPutV2 = async (url: string, param: any, option = {} as any) => {
  const token = mixToken()
  const formData = new FormData()

  Object.keys(param).forEach((keyParam: any) => {
    formData.append(keyParam, param[keyParam])
  })

  // Laravel expects _method for PUT
  formData.append('_method', 'PUT')

  const response = await fetch(`${API_URL}${url}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      // ❌ không thêm 'Content-Type'
    },
    body: formData,
  })

  if (!response.ok) {
    handleWriteDenied(response)
  }

  const temp = await response.json()
  return temp
}


export const mixDelV1 = async (url: string, param: {}) => {
  const response = await fetch(`${API_URL}${url}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: JSON.stringify(param),
  })
  if (!response.ok) {
    handleWriteDenied(response)
  }
  const temp = await response.json()
  return temp
}

export const mixTreeIds = (arr = [] as any) => {
  const res = [] as any
  arr.map((item: any) => {
    if (typeof item === 'number' && !isNaN(item)) {
      res.push(item)
    } else {
      const temp = item.split('-')
      res.push(parseInt(temp[1]))
    }
    return true
  })
  return res
}

export const mixGender = (valx: any) => {
  const list = [
    {
      value: 0,
      title: 'Chưa rõ',
    },
    {
      value: 1,
      title: 'Nam',
    },
    {
      value: 2,
      title: 'Nữ',
    },
    {
      value: 3,
      title: 'Khác',
    }
  ]
  const obs = {} as any
  list.map(val => {
    obs[`s${val.value}`] = val
    return true
  })
  if (valx || valx === 0) {
    return obs[`s${valx}`] || null
  }
  return list
}

export const mixGetTime = (dateString: any) => {
  const [day, month, year] = dateString.split("-")
  const dateObject = new Date(year, month - 1, day)
  return dateObject.getTime()
}

export const mixDate = (date = null, option = {} as any) => {
  let str = ''
  try {
    let d = new Date()
    if (date) {
      d = new Date(date)
    }
    const year = d.getFullYear()
    const month = (d.getMonth() + 1).toString().padStart(2, '0')
    const day = d.getDate().toString().padStart(2, '0')
    if (option.hour) {
      const hours = d.getHours().toString().padStart(2, '0')
      const minutes = d.getMinutes().toString().padStart(2, '0')

      str = `${day}${option.bass || '/'}${month}${option.bass || '/'}${year} ${hours}:${minutes}`
      return str
    }

    if (option.ishour) {
      let hour = d.getHours() as any
      let minute = d.getMinutes() as any
      if (hour < 10) {
        hour = `0${hour}`
      }
      if (minute < 10) {
        minute = `0${minute}`
      }
      str = `${hour}:${minute}`
      return str
    }

    if (option.month) {
      str = `${day}${option.bass || '-'}${month}`
      return str
    }
    if (option.year) {
      return year
    }

    str = `${day}${option.bass || '/'}${month}${option.bass || '/'}${year}`
  } catch (error) {
    str = `2${option.bass || '/'}2${option.bass || '/'}2022`
  }
  return str
}

export const datetimeFormat = (date: string) => {
  let result = ''

  try {
    const newDate = new Date(date)
    const _time = newDate.toLocaleTimeString("en-GB")
    const _date = newDate.toLocaleDateString("en-GB")
    result = `${_time} ${_date}`
  } catch (error) {
    result = ''
  }

  return result
}

export const mixDocSt = (valx: any) => {
  const list = [
    {
      value: 1,
      title: 'Đang xử lý',
    },
    {
      value: 2,
      title: 'Đang xem xét',
    },
    {
      value: 3,
      title: 'Hoàn thành',
    },
    {
      value: 4,
      title: 'Thất bại',
    },
  ]
  const obs = {} as any
  list.map(val => {
    obs[`s${val.value}`] = val
    return true
  })
  if (valx || valx === 0) {
    return obs[`s${valx}`] || null
  }
  return list
}

export const mixFirstChar = (str: any) => {
  let letter = 'AB'
  let lastIndex = str.lastIndexOf(' ')
  if (lastIndex === -1) {
    lastIndex = 0
  }
  try { letter = str.charAt(0) } catch (error) { }
  return letter
}

export const removeAccents = (str: any) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const mixSearch = (array: any, keyword: any) => {
  const normalizedKeyword = removeAccents(keyword.toLowerCase());

  return array.filter((item: any) => {
    return Object.values(item).some(value => {
      const normalizedValue = removeAccents(String(value).toLowerCase());
      return normalizedValue.includes(normalizedKeyword);
    });
  });
}

export const convertToMB = (fileSizeInBytes: any) => {
  const size = fileSizeInBytes ? fileSizeInBytes : 0
  let res = 0 as any
  try {
    const sizeInMB = size / (1024 * 1024)
    res = sizeInMB.toFixed(2)
  } catch (error) {
    res = 0
  }
  return `${res}MB`
}

export const mixGetImage = (url: string, params = {} as any) => {
  let res = null
  try {
    Object.keys(params).map((isKey, index) => {
      if (params[isKey] || params[isKey] === 0) {
        if (Array.isArray(params[isKey])) {
          params[isKey].map((val: any) => {
            url = `${url}${index === 0 ? '?' : '&'}${isKey}=${val}`
            return true
          })
        } else {
          url = `${url}${index === 0 ? '?' : '&'}${isKey}=${params[isKey]}`
        }
      }
      return null
    })
    res = `${API_URL}${url}`
  } catch (error) {
    res = null
  }
  return res
}

export const isImageURL = (url: any) => {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
  const lowerCaseURL = url.toLowerCase();
  return imageExtensions.some(extension => lowerCaseURL.endsWith(extension));
}

export const mixKhachHangStatus = (valx = null) => {
  const list = [
    {
      value: 0,
      text: 'Nhập mới',
      color: 'orange'
    },
    {
      value: 1,
      text: 'Mới',
      color: '#2db7f5'
    },
    {
      value: 2,
      text: 'Hẹn phỏng vấn',
      color: 'orange'
    },
    {
      value: 3,
      text: 'Đã chốt',
      color: 'cyan'
    },
    {
      value: 4,
      text: 'Hoàn thành',
      color: 'green'
    },
    {
      value: 5,
      text: 'Hủy',
      color: '#f50'
    }
  ]
  const obs = {} as any
  list.map(val => {
    obs[`s${val.value}`] = val
    return true
  })
  if (valx || valx === 0) {
    return obs[`s${valx}`] || list[0]
  }
  return list
}

export const mixHopDongStatus = (valx = null) => {
  const list = [
    {
      value: 1,
      text: 'Mới',
      color: '#2db7f5'
    },
    {
      value: 2,
      text: 'Hẹn phỏng vấn',
      color: 'orange'
    },
    {
      value: 3,
      text: 'Đã chốt',
      color: 'cyan'
    },
    {
      value: 4,
      text: 'Đợi duyệt',
      color: 'green'
    },
    {
      value: 5,
      text: 'Đổi người',
      color: 'orange'
    },
    {
      value: 6,
      text: 'Đã chốt',
      color: 'cyan'
    },
    {
      value: 7,
      text: 'Đợi duyệt',
      color: 'green'
    },
    {
      value: 8,
      text: 'Hủy',
      color: 'red'
    },
  ]
  const obs = {} as any
  list.map(val => {
    obs[`s${val.value}`] = val
    return true
  })
  if (valx || valx === 0) {
    return obs[`s${valx}`] || list[0]
  }
  return list
}

export const mixKhachHangType = (valx = null) => {
  const list = [
    {
      value: 1,
      text: 'Đi về',
      color: 'orange'
    },
    {
      value: 2,
      text: 'Theo giờ',
      color: '#2db7f5'
    },
    {
      value: 3,
      text: 'Thời vụ',
      color: 'orange'
    },
    {
      value: 4,
      text: 'Bao ăn ở lại',
      color: 'cyan'
    },
  ]
  const obs = {} as any
  list.map(val => {
    obs[`s${val.value}`] = val
    return true
  })
  if (valx || valx === 0) {
    return obs[`s${valx}`] || list[0]
  }
  return list
}

export const mixPrice = (val: any) => {
  let res = (new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(val))
  if (res === 'NaN ₫') {
    res = '0 ₫'
  }
  return res
}

export const mixWorkersStatus = (valx: any) => {
  const list = [
    {
      value: 1,
      text: 'Đợi việc',
      color: '#2db7f5'
    },
    {
      value: 2,
      text: 'Hoàn thành',
      color: 'green'
    },
    {
      value: 3,
      text: 'Hẹn phỏng vấn',
      color: 'orange'
    },
    {
      value: 4,
      text: 'Đã chốt',
      color: 'cyan'
    },
    {
      value: 5,
      text: 'Ở Nhà',
      color: '#f50'
    },
    {
      value: 6,
      text: 'Hủy',
      color: 'red'
    },
    {
      value: 7,
      text: 'Đã chốt',
      color: 'cyan'
    },
  ]
  const obs = {} as any
  list.map(val => {
    obs[`s${val.value}`] = val
    return true
  })
  if (valx || valx === 0) {
    return obs[`s${valx}`] || list[0]
  }
  return list
}

export const mixFutureTime = (valx = 60) => {
  let now = new Date()
  now.setMinutes(now.getMinutes() + valx)

  let yyyy = now.getFullYear();
  let mm = String(now.getMonth() + 1).padStart(2, '0')
  let dd = String(now.getDate()).padStart(2, '0')
  let hh = String(now.getHours()).padStart(2, '0')
  let min = String(now.getMinutes()).padStart(2, '0')
  let ss = String(now.getSeconds()).padStart(2, '0')

  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`
}

export const mixOutTime = (timeString = '') => {
  const targetTime = new Date(timeString);
  const now = new Date();
  return targetTime < now;
}

export const mixDayMore = (days = 0, type = '') => {
  const now = new Date();
  now.setDate(now.getDate() + days);

  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');
  let res = `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
  if (type === 'show') {
    res = `${dd}-${mm}`;
  }
  return res
}

export const mixHourDiff = (datetime1: any, datetime2: any) => {
  const date1 = new Date(datetime1) as any;
  const date2 = new Date(datetime2) as any;

  let diffInMs = Math.abs(date2 - date1); // Chênh lệch tính bằng mili-giây
  let diffInHours = diffInMs / (1000 * 60 * 60); // Chuyển sang giờ

  return diffInHours;
}

export const mixNumber = (num = 0) => {
  let res = 0 as any
  try {
    res = num.toString();
    if (num >= 1_000_000) {
      res = (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (num >= 1_000) {
      res = (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
  } catch (error) {
    res = 0
  }
  return res
}

export const mixMoreDay = (days = 0) => {
  const now = new Date();
  now.setDate(now.getDate() + days);

  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  const ss = String(now.getSeconds()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
}

export const mixDayExpiration = (expirationDate: any) => {
  let res = 0
  try {
    const now = new Date() as any;
    const expDate = new Date(expirationDate) as any;

    const diffTime = expDate - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    res = diffDays
  } catch (error) {
    res = 0
  }
  return res
}

export const mixTuyenDungStatus = (valx = null) => {
  const list = [
    {
      value: 1,
      text: 'Mới',
      color: 'green'
    },
    {
      value: 2,
      text: 'Đang hẹn',
      color: '#fbc660'
    },
    {
      value: 3,
      text: 'Đã đến',
      color: 'blue'
    },
    {
      value: 4,
      text: 'Đã duyệt',
      color: 'green'
    },
    {
      value: 5,
      text: 'Hủy',
      color: '#f50'
    }
  ]
  const obs = {} as any
  list.map(val => {
    obs[`s${val.value}`] = val
    return true
  })
  if (valx || valx === 0) {
    return obs[`s${valx}`] || list[0]
  }
  return list
}

export const mixSlug = (str: any) => {
  return str
    .toLowerCase()
    // Loại bỏ dấu tiếng Việt
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    // Thay thế ký tự đ, Đ
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')
    // Loại bỏ ký tự không phải chữ cái, số
    .replace(/[^a-z0-9\s-]/g, '')
    // Thay khoảng trắng bằng dấu gạch ngang
    .replace(/\s+/g, '-')
    // Loại bỏ các dấu gạch ngang liên tiếp
    .replace(/-+/g, '-')
    // Loại bỏ dấu gạch ngang ở đầu và cuối
    .replace(/^-+|-+$/g, '');
}

export const mixVNDtoUSA = (vnd: number, rate: number = 26371) => {
  if (!vnd) return 0;

  return vnd / rate
}

// Format chuẩn Việt Nam (VD: 1.000.000 ₫ hoặc 1.000.000)
export const mixformatCurrency = (amount?: number | null, showSymbol = true): string => {
  if (amount === undefined || amount === null || isNaN(amount)) return '0';
  
  if (!showSymbol) {
    return new Intl.NumberFormat('vi-VN').format(amount);
  }

  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
};